

















































import { Component, Vue, PropSync, Prop } from "vue-property-decorator";
import { FAIT_ASSETS } from "trade/constants";
import { C2COffer } from "@foxone/api/src/models/market";

@Component
class AssetForm extends Vue {
  @PropSync("fiatValue") bindFiatValue;

  @PropSync("fiatAsset") bindFiatAsset;

  @PropSync("wantedValue") bindWantedValue;

  @PropSync("wantedAsset") bindWantedAsset;

  @Prop() offer!: C2COffer;

  @Prop() loading!: boolean;

  @Prop() submitting!: boolean;

  @Prop({ default: true }) wantedSelect;

  @Prop() wantedAssets;

  @Prop() submitBtnText;

  get meta() {
    const wantedAssetPercision =
      (this.bindWantedAsset && this.bindWantedAsset.precision) || 0;
    const fiatValue = Number(this.bindFiatValue);

    const fiatAssets = FAIT_ASSETS.map(asset => ({
      id: asset.asset_id,
      ...asset
    }));

    const wantedAssets = this.wantedAssets.map(asset => ({
      id: asset.asset_id,
      ...asset
    }));

    let rules: any = [];
    let valid = false;
    let enabled = true;

    if (this.offer) {
      const { min_fiat: min, max_fiat: max } = this.offer;
      if (+max >= +min) {
        rules = [
          v => +v >= +min || this.$t("common.amount.min", { min: min }),
          v => +v <= +max || this.$t("common.amount.max", { max: max })
        ];
      } else {
        enabled = false;
      }
      valid = fiatValue >= +min && fiatValue <= +max;
    }

    return {
      enabled,
      valid,
      fiatRules: rules,
      wantedAssetPercision,
      fiatAssets: fiatAssets,
      fiatLabel: this.$t("trade.c2c.offer"),
      wantedAssets: wantedAssets,
      wantedLabel: this.$t("trade.c2c.get"),
      submitBtnDisabled: !(enabled && valid),
      submitBtnText: enabled
        ? this.$t("common.trade")
        : this.$t("common.trade.disabled")
    };
  }

  mounted() {
    this.bindFiatAsset = FAIT_ASSETS[0];

    const wanted = (this.$route.query.wanted as string) || "";
    const asset = this.wantedAssets.find(asset => {
      return (
        asset.asset_id === wanted ||
        asset.alia === wanted ||
        asset.symbol === wanted
      );
    });

    if (wanted && asset) {
      this.bindWantedAsset = asset;
    } else {
      this.bindWantedAsset = this.wantedAssets[0];
    }

    this.$nextTick(() => {
      if (this.$route.query.fiatAmount) {
        const fiatAmount = (this.$route.query.fiatAmount as string) || "";
        this.bindFiatValue = fiatAmount;
      } else {
        const wantedAmount = (this.$route.query.wantedAmount as string) || "";
        this.bindWantedValue = wantedAmount;
      }
    });
  }
}
export default AssetForm;
